import React, { useMemo } from "react";
import SummaryBox from "components/UniversalComponents/SummaryBox";

function RenderSummary({ data }) {

    function cleanObjects(arr) {
      return arr
        .map((obj) =>
          Object.fromEntries(Object.entries(obj).filter(([_, v]) => v ?? false))
        )
        .filter((obj) => Object.keys(obj).length);
    }

  const modified_data = useMemo(() => {
    return Object.entries(data)
      .filter(([key, _]) => key !== "last_updated")
      .sort(([, a], [, b]) => {
        if (a < b) return 1;
        if (a > b) return -1;
        return 0;
      })
      .map(([key, val]) => {
        const text_field = key;
        return { [text_field]: val };
      });
  }, [data]);

  return (
    <div>
      <div style={{ display: "flex", gap: "1.5rem", overflow: "auto" }}>
        {modified_data.map((obj, index) => {
          const [field_name, val] = Object.entries(obj)[0];
          if (field_name == "updated_at") return;
          return (
            <SummaryBox
              key={index}
              field={field_name}
              value={val}
              showFullWidth={cleanObjects(modified_data).length > 4}
            />
          );
        })}
      </div>
    </div>
  );
}

export default RenderSummary;
